import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Device } from '../osc-main-app-common/models/devices.models';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class DataHelperService {
    private devices: Array<Device>;

    constructor(private httpClient: HttpClient) {
    }

    /**
     * Devices
     */
    public getDevicesByCode(deviceModelCode: any): Observable<Array<Device>> {
        return this.getDevices()
            .pipe(
                map((devices: any) => {
                    return devices.filter(device => {
                        return device.modelCode.toLowerCase().startsWith(deviceModelCode);
                    });
                })
            );
    }

    public getDevices(): Observable<Array<Device>> {
        if (this.devices) {
            return of(this.devices);
        }
        let apiURL = '/api/tenant/devices';
        if (environment.USE_CONNECT_PLATFORM) {
            apiURL = environment.DEVICE_API_URL + '/v1/device/registered?deviceModelFamily=XRF&GetAll=true&onlyConfirmed=true'
        }

        return this.httpClient.get(apiURL).pipe(
            map((response: any) => {
                if (environment.USE_CONNECT_PLATFORM) {
                    this.devices = (response.result.items || []).map(item => ({
                        registrationId: item.id,
                        serialNumber: item.serialNumber,
                        modelName: item.device?.serie,
                        modelCode: item.device?.name,
                        displayName: item.device?.description,
                        registrationStatus: item.registrationStatus
                    }));
                } else {
                    this.devices = response || [];
                }
                return this.devices;
            })
        );

    }

    public clearDevicesCache(): void {
        this.devices = null;
    }
}
